import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { routeNode, routerStore } from 'core/routing';
import { useAppManager } from 'apps/hooks';

import { media } from 'legacyComponents/styled/styleUtils';
import { MainWrapper, Div } from 'legacyComponents/styled/lib';
import {
  SideNavBarWrapper,
  SideNavBar,
  SideNavBarItem,
  SideNavBarLink,
} from 'legacyComponents/sideNavBar';
import { RepoSpinner } from 'apps/repository/styles';

import { FourOhFour } from 'apps/fourOhFour';
import { AccountSettings } from 'apps/profile/settings/tabs/account/index';
import { NotificationSettings } from 'apps/profile/settings/tabs/notifications/index';
import { BillingSettings } from 'apps/profile/settings/tabs/billing';
import { RouterAppManager } from 'apps/profile/settings/appManager';

const viewsMap = {
  account: AccountSettings,
  notifications: NotificationSettings,
  billing: BillingSettings,
};

const ProfileSettings = withNamespaces()(
  observer(props => {
    const manager = useAppManager(RouterAppManager, null, {}, true, [
      props.route.params.spacePath,
    ]);
    const View = props.componentFromRoute();
    const { loading, notFound, isAllowed } = manager;

    if (loading) {
      return (
        <>
          <MainWrapper marginBottom='90px'>
            <RepoSpinner />
          </MainWrapper>
        </>
      );
    }

    if (notFound || !isAllowed) {
      return <FourOhFour />;
    }
    const {
      route: { name },
      routerStore: { params },
    } = props;
    const linkParams = { spacePath: params.get('spacePath') };

    return (
      <>
        {/* <Header /> */}
        <TopBarNoFlex className='noScrollBar'>
          <MySettings>
            {linkParams.spacePath}&apos;s <Trans>settings</Trans>
          </MySettings>
        </TopBarNoFlex>
        <MainWrapper>
          <Div display='inline-block' width='100%'>
            <SideNavBarWrapper>
              <SideNavBar>
                <SideNavBarItem isTitle>
                  <Trans>Personal Settings</Trans>
                </SideNavBarItem>
                <SideNavBarItem>
                  <SideNavBarLink
                    name='workspace.spaceSettings.account'
                    params={linkParams}
                    active={name === 'workspace.spaceSettings.account'}
                  >
                    <Trans>Account</Trans>
                  </SideNavBarLink>
                </SideNavBarItem>
                <SideNavBarItem>
                  <SideNavBarLink
                    name='workspace.spaceSettings.notifications'
                    params={linkParams}
                    active={name === 'workspace.spaceSettings.notifications'}
                  >
                    <Trans>Notifications</Trans>
                  </SideNavBarLink>
                </SideNavBarItem>
                <SideNavBarItem last>
                  <SideNavBarLink
                    name='workspace.spaceSettings.billing'
                    params={linkParams}
                    active={name.includes('billing')}
                  >
                    <Trans>Billing</Trans>
                  </SideNavBarLink>
                </SideNavBarItem>
              </SideNavBar>
            </SideNavBarWrapper>
            <SettingsWrapper>
              <View params={params} />
            </SettingsWrapper>
          </Div>
        </MainWrapper>
      </>
    );
  }),
);

export const SettingsWrapper = styled.div`
  width: calc(75% - 10px);
  float: right;
  margin-bottom: 60px;
  height: auto;
  ${media.l`
    width: calc(73% - 10px);
  `};
  ${media.m`
    width: 100%;
  `};
`;

const MySettings = styled.h1`
  /* font-size: 1.05em; */
`;

const TopBarNoFlex = styled.div`
  width: ${props => props.theme.layout.maxWidth};
  margin: 0 auto;
  z-index: 2;
  padding: ${props => props.theme.spacing.medium} 4vw;
  white-space: nowrap;
  overflow-x: auto;
`;

ProfileSettings.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

class RedirectToAccount extends React.Component {
  constructor(props) {
    super(props);
    const {
      route: { params },
    } = routerStore;
    routerStore.navigate(`workspace.spaceSettings.account`, params, {
      replace: true,
    });
  }

  render() {
    return null;
  }
}

export const ProfileSettingsRouter = routeNode(
  'workspace.spaceSettings',
  viewsMap,
  RedirectToAccount,
)(ProfileSettings);
